import { z } from 'zod';
import { PlatformRole } from '../types.js';
/**
 * Query of every superadmin console list (users, islands, organizations).
 * There is no pagination: lists return at most ADMIN_LIST_LIMIT rows plus a
 * `truncated` flag, and the operator narrows them with `q`.
 */
export const AdminListQuerySchema = z.object({
    q: z.string().trim().max(100, 'Search must be at most 100 characters').optional()
});
/** Superadmin granting or revoking the platform role of another account (§4.3). */
export const SetPlatformRoleSchema = z.object({
    platformRole: z.nativeEnum(PlatformRole, { required_error: 'Platform role is required' })
});
/** Superadmin renaming an organization; names are unique case-insensitively (§3.1 invariant 5). */
export const RenameOrganizationSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Organization name is required')
        .max(100, 'Organization name must be at most 100 characters')
});
